import React, { useState, useEffect } from "react";
import Wizard from "./Wizard";
import { GetResourcesByList } from "../../api/services/shell";
import LanguageContext from "../../language";
import PropTypes from "prop-types";
import { onWarning } from "../../components/shared/messages";
import { Guests } from "../../api/services/next";
import { Languages } from "../../components/shared/constants";

export default function WizardWrapper({ reservationDetails }) {
  const [guestLangTexts, setGuestLangTexts] = useState();
  const [guest, setGuest] = useState({});
  const guestTexts = [
    "FirstName",
    "LastName",
    "Email",
    "Address",
    "City",
    "ZipCode",
    "Country",
    "Birthday",
    "Phone",
    "Passport",
    "Number",
    "CheckIn",
    "CheckOut",
    "ReservationCheckIn",
    "NoRoomRequested",
    "Nights",
    "Pax",
    "TotalPayment",
    "TotalBalance",
    "ID",
    "Documents",
    "GuestDetails",
    "Payment",
    "Confirmation",
    "UploadPassportOrIDFiles",
    "Amount",
    "Currency",
    "ShowAllRelatedCards",
    "SavedCards",
    "SavedAuthorizations",
    "ExternalPayments",
    "AddCreditCard",
    "Guest",
    "IAgreeTo",
    "Signature",
    "Next",
    "MakePayment",
    "Close",
    "Save",
    "Required",
    "Entity",
    "Expiry",
  ];
  const guestMessages = [
    "ReservationFilesUploaderSubtitle",
    "FileUploadError",
    "AgreeToTermsAndPrivaryAndSign",
    "PassportNotInFormat",
    "FileUploadedSuccessfully",
    "GuestUpdatedSuccessfully",
    "PleaseFillCreditCardDetails",
    "RoomDirty",
    "CannotPerformCheckIn",
  ]
  useEffect(() => {
    (async () => {
      try {
        if (reservationDetails) {
          let guest = await Guests.GetGuest(reservationDetails.GuestId, { IncludeLocation: true });
          setGuest(guest);
          setGuestLangTexts(await GetResourcesByList(guest?.LanguageId === 7? 7 : Languages.English.ID, guestMessages, guestTexts));
        }
      } catch (error) {
        onWarning(error);
      }
    })();
  }, [reservationDetails]);
  return (
    <LanguageContext.Provider key="guest-step" value={guestLangTexts}>
      {guestLangTexts && <Wizard reservationDetails={{...reservationDetails, Guest: guest}} />}
    </LanguageContext.Provider>
  );
}

WizardWrapper.propTypes = {
  reservationDetails: PropTypes.object,
};
